import { Component, OnInit, ViewChild,AfterViewInit  } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { MatHorizontalStepper, MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { AddSmspdpConfigTableComponent } from '../add-smspdp-config-table/add-smspdp-config-table.component';
import { FormBuilder, FormGroup,Validators} from '@angular/forms';
import { AddEcowasBusinessConfigComponent } from '../add-ecowas-business-config/add-ecowas-business-config.component';
import { DataSharingService } from 'src/app/service/data-sharing.service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-add-sms-pdp-live-service-configuration',
  templateUrl: './add-sms-pdp-live-service-configuration.component.html',
  styleUrls: ['./add-sms-pdp-live-service-configuration.component.scss']
})
export class AddSmsPdpLiveServiceConfigurationComponent implements OnInit {
 
  addCountryDetailsFormGroup: FormGroup;
  addSmspdpFormGroup: FormGroup;
  smspsdEcowasFormGroup: FormGroup;
  smspdpLiveMappingFormGroup:FormGroup;
  addSmspdpThresholdFormGroup: FormGroup;
  allowedGtFormGroup: FormGroup;
  addCcNdcFormGroup:FormGroup;
  addMccMncFormGroup:FormGroup;
  addThresholdConfigformGroup:FormGroup;
  // ProballowedGtFormGroup:FormGroup;
  addProbDBCcNdcFormGroup:FormGroup;
  addProbdbMccMncFormGroup:FormGroup;
  addEcowasRrmsOrganizationFormGroup:FormGroup;
  addBusinessForm:FormGroup;

  @ViewChild(MatStepper,{static:false}) stepper: MatStepper;
  submitted:boolean=false;
  submitted1:boolean=false;
  submitted2:boolean=false;

  submitted3:boolean=false;
  submitted5:boolean=false;

  submitted6:boolean=false;
  submitted7:boolean=false;
  submitted8:boolean=false;
  submitted9:boolean=false;
  submitted10:boolean=false;
  submitted11:boolean=false;
  submitted12:boolean=false;
  submitted13:boolean=false;
  homeOrgidValue:any;
  //country:any=['AFGHANISTAN','BENIN','CAMEROON','CONGO BRAZZAVILLE','COTE DIVOIRE','GHANA','GUINEA BISSAU','LIBERIA','NIGERIA','RWANDA','SOUTH AFRICA','SOUTH SUDAN','SUDAN','SWAZILAND','UGANDA','ZAMBIA'];
  country:any=['SOUTH AFRICA'];
  //NodeValue:any=['app1','app2','app3','app4']
  NodeValue:any=['app4']


  orgid:any;
  nType:any;
  mccvalue:any;
  mncValue:any;
  ccValue:any;  
  ndcValue:any;
  TapCodeValue:any;
  vpmnCountryValue:any;
  vpmnNetworkValue:any;

  constructor(private dialog: MatDialog, private router:Router,
    private dataSharingService: DataSharingService,private formBuilder:FormBuilder , private endpointsService: EndpointsService,
    private backendApiService: BackendApiService, private spinnerService:Ng4LoadingSpinnerService) { }

  ngOnInit(): void {
    this.smspdpConfig()
  }
  addRrmsEcowasOrganization(){
    this.addEcowasRrmsOrganizationFormGroup = this.formBuilder.group({
    //  orgId:[],
      type:['app4',Validators.required],
      country_name:['',Validators.required],
      operator:['',Validators.required],
      tadIg:['',Validators.required],
      mcc:['',Validators.required],
      mnc:['',Validators.required],
      cc:['',Validators.required],
      ndc:['',Validators.required],
    })
    this.addCountryDetailsForm();
    this.addBusinessConfigForm();
    
  }
   addBusinessConfigForm(){
      this.addBusinessForm = this.formBuilder.group({
        orgId :['6108',Validators.required],
      // roamOrgId : ['',Validators.required],
      //type : ['',Validators.required],
      ecowas_enabled : [''],
      message_enabled :[''],
      charging_enabled :[''],
      iot_signed :[''],
      tarrif_sno : [''],
      tarriff_name : [''],
      // created_date : [],
      // modified_date : [],
      freeRoamValidity :['30'],
      counterValidity :['30'],
      messageInterval : ['1'],
      stayHomeInterval : ['7'],
      counterStayHomeInterval : ['7'],
      ratesApplied : ['4'],
      moc :['1'],
      mtc:['1'],
      smsmo:['1'],
      grps:['1'],
      dataOthers:['1'],
      mocNoOfDaysApplied:['1'],
      mtcNoOfDaysApplied:['1000'],
      smsmoNoOfDaysApplied:['1000'],
      gprsNoOfDaysApplied:['1000'],
      dataNoOfDaysApplied:['1000'],
      communityId:[''],
      communityName:['ECOWAS'],
      whitelist_enabled:[''],
      // vistingCountry:[''],
      // vistingNetwork:[''],
      primaryType:[''],
      should_run_primary:[''],
      should_run_slave:['']
      })
      
    }
  smspdpConfig(){
    this.addSmspdpFormGroup = this.formBuilder.group({   
     
    service_name:['GHANA'],
    spId:['333'],
    productId:['222'],
    serviceId:['111'],
    shortCode:['MTN-Roaming'],
   

    })
    this.smspdpEcowasConfig();
  }
  
  smspdpEcowasConfig(){
    this.smspsdEcowasFormGroup = this.formBuilder.group({
      // orgId:['',Validators.required],
      sms_threshold:['1'],
      call_threshold:['3000'],
      created_date:[],
      is_live:['Y'],
      unblock_sms:[],
      send_unblock_sms:['Y'],
      block_sms:[],
      unblock_internet:[],
      block_internet:[],
      unblock_sms_data:[],
      block_sms_data:['block_data'],
      send_unblockinternet_sms:['N'],
      send_unblock_sms_data:['N'],
      send_block_sms_data:['N'],
      send_block_internet_data:['N']
    })
    this.smspdpLiveMap()
  }
  smspdpLiveMap(){
    this.smspdpLiveMappingFormGroup = this.formBuilder.group({
      
       //orgId:['6108',Validators.required],
      //vistingOrgId:['6040',Validators.required],
      vistingCC:['225'],
      created_date_time:[],
      homeCC:['27',Validators.required]
    })
    this.addsmspdpThresold()
  }
  addsmspdpThresold(){
    this.addSmspdpThresholdFormGroup = this.formBuilder.group({
      // orgId:['',Validators.required],
      vistingOrgId:['',Validators.required],
      offerName:[''],
      threshHoldValue:['',Validators.required]

    })
    this.addccNdcForm();
  }
  addEcowasAllowedGtForm(){
    this.allowedGtFormGroup = this.formBuilder.group({
      // orgId :['',Validators.required],
      gt:['',Validators.required]
    })
    this.addccNdcForm()
  }
  addccNdcForm(){
    this.addCcNdcFormGroup = this .formBuilder.group({
      // orgId:['',Validators.required],
      cc:['229',Validators.required],
      ndc:['98',Validators.required],
      // tapCode:['',Validators.required]
     
    })
   this.addMccMncDetailsForm();
  }
  addMccMncDetailsForm(){
    this.addMccMncFormGroup = this.formBuilder.group({
      // orgId:['',Validators.required],
      mcc:['611',Validators.required],
      mnc:['30',Validators.required],
      tapCode:['',Validators.required]
    })
    this.addThresholdConfigForm()
  }
  addThresholdConfigForm(){
    this.addThresholdConfigformGroup = this.formBuilder.group({
      // orgId :['',Validators.required],
     // vistingOrgId:['93',Validators.required],
      offerName:[''],
      SMSThreshHoldValue:[''],
      DataThresholdValue:['']
    
      
    })
   this.addProbDBccndcForm();
  }
  // addProbDBAllowedGt(){
  //   this.ProballowedGtFormGroup = this.formBuilder.group({
  //     // orgId:['',Validators.required],
  //     gt:['',Validators.required]
  //   })
  //   this.addProbDBccndcForm();
  // }
  addProbDBccndcForm(){
    this.addProbDBCcNdcFormGroup = this .formBuilder.group({
      // orgId:['',Validators.required],
      // cc:['229',Validators.required],
      // ndc:['98',Validators.required],
      //tapCode:['',Validators.required]
     
    })
  this.addProbdbmccMncForm()
  }
  addProbdbmccMncForm(){
    this.addProbdbMccMncFormGroup = this.formBuilder.group({
      // orgId:['',Validators.required],
      // mcc:['611',Validators.required],
      // mnc:['30',Validators.required],
      // tapCode:['',Validators.required]
    })
    this.addRrmsEcowasOrganization();
    this.addEcowasAllowedGtForm();
  }
 
  
  addCountryDetailsForm(){
    this.addCountryDetailsFormGroup = this.formBuilder.group({
      // orgId :['',Validators.required],
      country:['SOUTH AFRICA',Validators.required],
      msisdn:[''],
      //roamOrgId:['',Validators.required],
      // type:['',Validators.required]
     // gt:['',Validators.required]
    })
  }
  get f(){
    return this.addSmspdpFormGroup.controls;
    
   }
   get g(){
    return this.smspsdEcowasFormGroup.controls;
    
   }
   get h(){
    
    return this.addSmspdpThresholdFormGroup.controls;
   }
   get i(){
    return this.smspdpLiveMappingFormGroup.controls;
    
   }
   get k(){
    return this.addCountryDetailsFormGroup.controls;
  }
  get m(){
    return this.allowedGtFormGroup.controls;
  }
  get n(){
    return this.addCcNdcFormGroup.controls;
  }
  get p(){
    return this.addMccMncFormGroup.controls;
  }
  get q(){
    return this.addThresholdConfigformGroup.controls;
  }
  // get r(){
  //   return this.ProballowedGtFormGroup.controls;
  // }
  get s(){
    return this.addProbDBCcNdcFormGroup.controls;
  }
  get t(){
    return this.addProbdbMccMncFormGroup.controls;
  }
  get u(){
    return this.addEcowasRrmsOrganizationFormGroup.controls;
  }
  get v(){
    return this.addBusinessForm.controls;
    
   }

   onAddCountryDetails(){
    this.submitted5=true;
    if (this.addCountryDetailsFormGroup.invalid) {
     return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_SMSPDP_COUNTRYDATA + 
      '&orgId=' + this.homeOrgidValue +
      '&roamOrgId=' + this.orgid +
      '&msisdn=' + this.addCountryDetailsFormGroup.get('msisdn').value +
      '&country=' + this.addCountryDetailsFormGroup.get('country').value +
      '&table=smspdp_live_mapping_copy' +
      '&visitingCountry=' + this.vpmnCountryValue +
      // '&gt=' + this.addCountryDetailsFormGroup.get('gt').value + 
      '&type=' + this.nType +
      '&created_by=' + sessionStorage.getItem('ecowas_user_name')
      )
      .subscribe(response => {
        console.log("response",response)
        alert('Service Added successfully');        
         this.spinnerService.show();
         this.router.navigate(['/service-live-dashboard/sms-pdp-service-live-dashboard']).then()
      })
   }
   onAdd12(){
    this.submitted13=true;
    if(this.addEcowasRrmsOrganizationFormGroup.invalid){
      return;
    }
    
    
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_ORGANIZATION_CONFIG +
      // '&orgId=' + this.orgid +  
      '&type=' + this.addEcowasRrmsOrganizationFormGroup .get('type').value +
      '&country_name=' + this.addEcowasRrmsOrganizationFormGroup .get('country_name').value+
      '&operator=' + this.addEcowasRrmsOrganizationFormGroup .get('operator').value+
      '&tadIg=' + this.addEcowasRrmsOrganizationFormGroup .get('tadIg').value+
      '&mcc=' + this.addEcowasRrmsOrganizationFormGroup .get('mcc').value+
      '&mnc=' + this.addEcowasRrmsOrganizationFormGroup .get('mnc').value+
      '&cc=' + this.addEcowasRrmsOrganizationFormGroup .get('cc').value+
      '&ndc=' + this.addEcowasRrmsOrganizationFormGroup .get('ndc').value
     
  
      )
      .subscribe(response => {
        console.log("responseeee",response);
        this.orgid=response[0].orgId;
        console.log("/////",this.orgid);
        this.nType = this.addEcowasRrmsOrganizationFormGroup .get('type').value
        this.mccvalue=this.addEcowasRrmsOrganizationFormGroup .get('mcc').value;
        this.mncValue = this.addEcowasRrmsOrganizationFormGroup .get('mnc').value;
        this.ccValue = this.addEcowasRrmsOrganizationFormGroup .get('cc').value;
        this.ndcValue = this.addEcowasRrmsOrganizationFormGroup .get('ndc').value;
        this.TapCodeValue = this.addEcowasRrmsOrganizationFormGroup .get('tadIg').value;
        this.vpmnCountryValue = this.addEcowasRrmsOrganizationFormGroup .get('country_name').value;
        this.vpmnNetworkValue = this.addEcowasRrmsOrganizationFormGroup .get('operator').value
  })
   }
   onAdd14(){
    console.log('hii');
    this.submitted=true;
 
 if (this.addBusinessForm.invalid) {
  return;
 }
//  this.orgid=this.addBusinessForm.get('orgId').value;
//  console.log("aaa",this.orgid)
// this.stepper.next();
// this.orgIdData =this.addBusinessForm.get('orgId').value;
 // this.addBusinessForm.get('orgId').setValue( this.addBusinessForm.get('orgId').value);
   this.backendApiService.callToApi(this.endpointsService.URL_ADD_BUSINESS_CONFIG +
     '&orgId=' + this.addBusinessForm.get('orgId').value+
     '&roamOrgId=' +this.orgid +
     '&ecowas_enabled=' + this.addBusinessForm.get('ecowas_enabled').value+
     '&message_enabled=' + this.addBusinessForm.get('message_enabled').value+
     '&charging_enabled=' + this.addBusinessForm.get('charging_enabled').value+
     '&iot_signed=' + this.addBusinessForm.get('iot_signed').value+
     '&tarrif_sno=' + this.addBusinessForm.get('tarrif_sno').value+
     '&tarriff_name=' + this.addBusinessForm.get('tarriff_name').value+
     '&freeRoamValidity=' + this.addBusinessForm.get('freeRoamValidity').value+
     '&counterValidity=' + this.addBusinessForm.get('counterValidity').value+
     '&messageInterval=' + this.addBusinessForm.get('messageInterval').value+
     '&stayHomeInterval=' + this.addBusinessForm.get('stayHomeInterval').value+
     '&counterStayHomeInterval=' + this.addBusinessForm.get('counterStayHomeInterval').value+
     '&ratesApplied=' + this.addBusinessForm.get('ratesApplied').value+
     '&moc=' + this.addBusinessForm.get('moc').value+
     '&mtc=' + this.addBusinessForm.get('mtc').value+
     '&smsmo=' + this.addBusinessForm.get('smsmo').value+
     '&grps=' + this.addBusinessForm.get('grps').value+
     '&dataOthers=' + this.addBusinessForm.get('dataOthers').value+
     '&mocNoOfDaysApplied=' + this.addBusinessForm.get('mocNoOfDaysApplied').value+
     '&mtcNoOfDaysApplied=' + this.addBusinessForm.get('mtcNoOfDaysApplied').value+
     '&smsmoNoOfDaysApplied=' + this.addBusinessForm.get('smsmoNoOfDaysApplied').value+
     '&gprsNoOfDaysApplied=' + this.addBusinessForm.get('gprsNoOfDaysApplied').value+
     '&dataNoOfDaysApplied=' + this.addBusinessForm.get('dataNoOfDaysApplied').value+
     '&communityId=' + this.addBusinessForm.get('communityId').value+
     '&communityName=' + this.addBusinessForm.get('communityName').value+
     '&whitelist_enabled=' + this.addBusinessForm.get('whitelist_enabled').value+
     '&vistingCountry=' + this.vpmnCountryValue+
     '&vistingNetwork=' + this.vpmnNetworkValue
     +'&primaryType=' + this.addBusinessForm.get('primaryType').value+
     '&should_run_primary=' + this.addBusinessForm.get('should_run_primary').value+
     '&should_run_slave=' + this.addBusinessForm.get('should_run_slave').value+
     '&type=' + this.nType 
    
     
     

     )
     .subscribe(response => {
       console.log("responseeee",response);
       this.homeOrgidValue = this.addBusinessForm.get('orgId').value
 //       if (response === null || response === false ) {
 //         alert('Not Added');
 //         return;
 //       }
 //       else if(response === '{\"status\": \"Record with orgId already exists\"}'){
 //         alert("Record with orgid already exit")
 //       }
 //        else {
 //         alert('Add successfully');        
 //         this.spinnerService.show();
 //sessionStorage.setItem('orgIdv',this.addBusinessForm.get('orgId').value );
 //       }
  })
 }
  onAdd(){
    this.submitted=true;
    if (this.addSmspdpFormGroup.invalid) {
     return;
    }
    //this.orgid=this.addSmspdpFormGroup.get('orgId').value;
 console.log("aaa",this.orgid)
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_SMSPDP_CONFIG +
      '&orgId=' + this.orgid +   '&type=' + this.nType +
      '&service_name=' + this.addSmspdpFormGroup.get('service_name').value+
      '&spId=' + this.addSmspdpFormGroup.get('spId').value+
      '&productId=' + this.addSmspdpFormGroup.get('productId').value+
      '&serviceId=' + this.addSmspdpFormGroup.get('serviceId').value+
      '&shortCode=' + this.addSmspdpFormGroup.get('shortCode').value
      )
      .subscribe(response => {
        console.log("responseeee",response)
      // if (response === null || response === false ) {
      //   alert('Not Added');
      //   return;
      // }
      // else if(response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }
      //  else {
      //   alert('Add successfully');        
      //   this.spinnerService.show();
       
      // }
  })
  }
  onAdd1(){
    this.submitted1=true;
    if (this.smspsdEcowasFormGroup.invalid) {
     return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_SMSPDP_CONFIG +
      '&orgId=' + this.orgid+ '&type=' + this.nType +
      '&sms_threshold=' + this.smspsdEcowasFormGroup.get('sms_threshold').value+
      '&call_threshold=' + this.smspsdEcowasFormGroup.get('call_threshold').value+
      // '&created_date=' + this.smspsdEcowasFormGroup.get('created_date').value+
      '&is_live=' + this.smspsdEcowasFormGroup.get('is_live').value+
      '&unblock_sms=' + this.smspsdEcowasFormGroup.get('unblock_sms').value+
      '&send_unblock_sms=' + this.smspsdEcowasFormGroup.get('send_unblock_sms').value+
      '&block_sms=' + this.smspsdEcowasFormGroup.get('block_sms').value+
      '&unblock_internet=' + this.smspsdEcowasFormGroup.get('unblock_internet').value+
      '&block_internet=' + this.smspsdEcowasFormGroup.get('block_internet').value+
      '&unblock_sms_data=' + this.smspsdEcowasFormGroup.get('unblock_sms_data').value+
      '&block_sms_data=' + this.smspsdEcowasFormGroup.get('block_sms_data').value+
      '&send_unblockinternet_sms=' + this.smspsdEcowasFormGroup.get('send_unblockinternet_sms').value+
      '&send_unblock_sms_data=' + this.smspsdEcowasFormGroup.get('send_unblock_sms_data').value+
      '&send_block_sms_data=' + this.smspsdEcowasFormGroup.get('send_block_sms_data').value+
      '&send_block_internet_data=' + this.smspsdEcowasFormGroup.get('send_block_internet_data').value
      
      )
      .subscribe(response => {
        console.log("responseeee",response)
      // if (response === null || response === false ) {
      //   alert('Not Added');
      //   return;
      // }
      // else if(response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }
      //  else {
      //   alert('Added successfully');        
      //   this.spinnerService.show();
       
      // }
  })
  }
  onAdd2(){
    this.submitted3=true;
    if (this.smspdpLiveMappingFormGroup.invalid) {
     return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_SMSPDP_LIVE_MAPPING_CONFIG +
    
      '&vistingOrgId=' + this.orgid+  '&type=' + this.nType +
      '&orgId=' +this.homeOrgidValue +
      
      '&vistingCC=' + this.ccValue +
      // '&created_date_time=' + this.smspdpLiveMappingFormGroup.get('created_date_time').value+
      '&homeCC=' + this.smspdpLiveMappingFormGroup.get('homeCC').value

      
      )
      .subscribe(response => {
        console.log("responseeee",response);
       
        
        // if (response === null || response === false ) {
        //   alert('Not Added');
        //   return;
        // }
        // else if(response === '{"status" : "Record with orgId already exists"}'){
        //   alert("Record with orgid already exit")
        // }
        //  else {
        //   alert('Add successfully');        
        //   this.spinnerService.show();
         
        // }
  })
  }
  onAdd3(){
    this.submitted2=true;
    if (this.addSmspdpThresholdFormGroup.invalid) {
     return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_SMSPDP_THRESOLD_CONFIG +
      
       '&orgId=' + this.orgid+  '&type=' + this.nType +
      '&vistingOrgId=' + this.addSmspdpThresholdFormGroup.get('vistingOrgId').value+
      '&offerName=' + this.addSmspdpThresholdFormGroup.get('offerName').value+
      '&threshHoldValue=' + this.addSmspdpThresholdFormGroup.get('threshHoldValue').value
     
      
      )
      .subscribe(response => {
        console.log("responseeee",response)
        // if (response === null || response === false ) {
        //   alert('Not Added');
        //   return;
        // }
        // else if(response === '{"status" : "Record with orgId already exists"}'){
        //   alert("Record with orgid already exit")
        // }
        //  else {
        //   alert('Added successfully');        
        //   this.spinnerService.show();
        //   this.router.navigate(['/service-live-dashboard/sms-pdp-service-live-dashboard']).then()
        // }
  })
  }

  skipStep(stepper: MatHorizontalStepper) {

    const currentStep = stepper.selected;
    const originalControl = currentStep.stepControl;
  
    // Temporarily clear validation
    currentStep.stepControl = null;
  
    // Mark the current step as completed
    currentStep.completed = true;
  
    // Move to next step
    stepper.next();
  
    // Restore control after short delay
    setTimeout(() => {
      currentStep.stepControl = originalControl;
    });
  }
  
  
  onAdd5(){
    console.log("oooooo")
    this.submitted6=true;
    if(this.allowedGtFormGroup.invalid){
      return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_ALLOWED_GT +
    // '&orgId=' + this.homeOrgidValue + 
      '&type=' + this.nType +
      //'&vistingOrgId=' + this.orgid+
      '&gt=' + this.allowedGtFormGroup .get('gt').value
     
  
      )
      .subscribe(response => {
        console.log("responseeee",response)
      // if (response === null || response === false ) {
      //   alert('Not Added');
      //   return;
      // }
      // else if(response === '{"status" : "Record with orgId already exists"}'){
      //   alert("Record with orgid already exit")
      // }
      //  else {
      //   alert('Add successfully');        
      //   this.spinnerService.show();
       
      // }
  })
   }
   onAdd6(){
    // this.submitted7=true;
    // if(this.addCcNdcFormGroup.invalid){
    //   return;
    // }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOEAS_CC_NDC +
      '&orgId=' + this.orgid +  '&type=' + this.nType +
      '&cc=' + this.addCcNdcFormGroup .get('cc').value+
      '&ndc=' + this.addCcNdcFormGroup .get('ndc').value+
      '&tapCode=' + this.TapCodeValue
     
  
      )
      .subscribe(response => {
        console.log("responseeee",response)
  })
   }
   onAdd7(){
    this.submitted8=true;
    if(this.addMccMncFormGroup.invalid){
      return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_MCC_MNC +
      '&orgId=' + this.orgid +  '&type=' + this.nType +
      '&mcc=' + this.addMccMncFormGroup .get('mcc').value+
      '&mnc=' + this.addMccMncFormGroup .get('mnc').value+
      '&tapCode=' + this.addMccMncFormGroup .get('tapCode').value
     
  
      )
      .subscribe(response => {
        console.log("responseeee",response)
  })
   }
   onAdd8(){
    this.submitted9=true;
    if(this.addThresholdConfigformGroup.invalid){
      return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_ECOWAS_THRESHOLD_CONFIG +
      '&orgId=' + this.homeOrgidValue +  '&type=' + this.nType +
      '&roamOrgId=' + this.orgid+
      '&offerName=' + this.addThresholdConfigformGroup .get('offerName').value+
      '&SMSThreshHoldValue=' + this.addThresholdConfigformGroup .get('SMSThreshHoldValue').value+
      '&DataThresholdValue=' + this.addThresholdConfigformGroup .get('DataThresholdValue').value
     
  
      )
      .subscribe(response => {
        console.log("responseeee",response)
  })
   }
  //  onAdd9(){
  //   this.submitted10=true;
  //   if(this.ProballowedGtFormGroup.invalid){
  //     return;
  //   }
  //   this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_PROBRDB_ALLOWED_GT +
  //     '&orgId=' + this.orgid +  '&type=' + this.nType +
  //     '&gt=' + this.ProballowedGtFormGroup .get('gt').value
      
     
  
  //     )
  //     .subscribe(response => {
  //       console.log("responseeee",response)
  // })
  //  }
   onAdd10(){
    this.submitted11=true;
    if(this.addProbDBCcNdcFormGroup.invalid){
      return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_PROBDB_CC_NDC +
      '&orgId=' + this.homeOrgidValue +  '&type=' + this.nType +
      '&roamOrgId=' + this.orgid+
      '&cc=' + this.ccValue+
      '&ndc=' + this.ndcValue+
      '&tapCode=' + this.TapCodeValue
     
  
      )
      .subscribe(response => {
        console.log("responseeee",response);
       this.TapCodeValue = this.addProbDBCcNdcFormGroup .get('tapCode').value
  })
   }
   onAdd11(){
    this.submitted12=true;
    if(this.addProbdbMccMncFormGroup.invalid){
      return;
    }
    this.backendApiService.callToApi(this.endpointsService.URL_ADD_RRMS_PROBDB_MCC_MNC +
      '&orgId=' + this.homeOrgidValue +  '&type=' + this.nType +
      '&roamOrgId=' + this.orgid+
      '&mcc=' + this.mccvalue+
      '&mnc=' + this.mncValue+
      '&tapCode=' + this.TapCodeValue
     
  
      )
      .subscribe(response => {
        console.log("responseeee",response)
  })
   }
   
  goBckword(){
    this.router.navigate(['/service-live-dashboard/sms-pdp-service-live-dashboard']).then()
   
  }
  // aaa(){
  //   const addSmspdpFormGroup = this.smspdpConfig.addSmspdpFormGroup;
  //   console.log("ssss",addSmspdpFormGroup)
  // }
  ngAfterViewInit() {
    console.log("aaaa")
    // Accessing child component's form group after view initialization
  
      // const childFormGroup = this.smspdpConfig.addSmspdpFormGroup.value;
      // // Now you have access to the child form group in the parent component
      // console.log('Child Form Group:', childFormGroup);
    
  }

}
